import { render, staticRenderFns } from "./KnowledgeBaseCategories.vue?vue&type=template&id=b36f40c2&scoped=true&"
import script from "./KnowledgeBaseCategories.vue?vue&type=script&lang=ts&"
export * from "./KnowledgeBaseCategories.vue?vue&type=script&lang=ts&"
import style0 from "./KnowledgeBaseCategories.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./KnowledgeBaseCategories.vue?vue&type=style&index=1&id=b36f40c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36f40c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol})
